// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fade-enter[data-v-f2348e4a]{opacity:0}.fade-enter-active[data-v-f2348e4a]{transition:.5s}.fade-enter-to[data-v-f2348e4a]{opacity:1}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
